(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vaccine', {
            parent: 'entity',
            url: '/vaccine',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vaccines'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vaccine/vaccines.html',
                    controller: 'VaccineController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('vaccine-detail', {
            parent: 'vaccine',
            url: '/vaccine/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vaccine'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vaccine/vaccine-detail.html',
                    controller: 'VaccineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Vaccine', function($stateParams, Vaccine) {
                    return Vaccine.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'vaccine',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('vaccine-detail.edit', {
            parent: 'vaccine-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vaccine/vaccine-dialog.html',
                    controller: 'VaccineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Vaccine', function(Vaccine) {
                            return Vaccine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vaccine.new', {
            parent: 'vaccine',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vaccine/vaccine-dialog.html',
                    controller: 'VaccineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vaccine', null, { reload: 'vaccine' });
                }, function() {
                    $state.go('vaccine');
                });
            }]
        })
        .state('vaccine.edit', {
            parent: 'vaccine',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vaccine/vaccine-dialog.html',
                    controller: 'VaccineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Vaccine', function(Vaccine) {
                            return Vaccine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vaccine', null, { reload: 'vaccine' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vaccine.delete', {
            parent: 'vaccine',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vaccine/vaccine-delete-dialog.html',
                    controller: 'VaccineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Vaccine', function(Vaccine) {
                            return Vaccine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vaccine', null, { reload: 'vaccine' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
